<template>
<div class=""  style="">

   <div class="title_h1 yo-color-primary">AUTHOR MANAGEMENT</div>
   <div class="yo-text-s yo-color-secondary" style="margin:8px 0 24px 0;">» {{$abstract.profile.row.titolo}}</div>

 
   <div v-if="step==0">
      List of the authors of your abstract. 
      <br />
      Click on the author's name to choose the presenting author and change their position in the list (move up/move down)
      <br />
      Please remember to include the presenting author.
      <br />
      The name of the PRESENTING AUTHOR will be underlined.

      


      <div class="row pad" style="margin-top:20px;border-bottom:1px solid lightgrey;padding-bottom:30px;padding-bottom:30px;">
         
         <div class="col s6 m8 ">
               <div style="line-height:38px;">To insert a new author click on "Add author"</div>
         </div>

         <div class="col s6 m4 ">
               <el-button type="primary" @click="addAbsautore" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;">ADD AUTHOR</el-button>
         </div>
      </div>


      <br /><br />
      
      <el-collapse accordion>
      <autoreAbstract v-for="item in $abstract._autore" :item="item" v-bind:key="item.id" ></autoreAbstract> 
      </el-collapse>


      <div class="row pad" style="margin-top:20px;border-top:1px solid lightgrey;padding-top:30px;padding-bottom:30px;">
         <div class="col s6 m2 ">
               <el-button type="info" style="width:100%;margin:10px 0;"  @click="onCancel">Back to Abstracts</el-button>
         </div>
         

      </div>


   </div>

   <div v-if="step==1">
      

      <div style="margin-top:32px;">If the author you want to add is not among those present in our archive, enter it as a new author by clicking "NEW AUTHOR"</div>

      <div class="row pad" style="margin-top:20px;border-top:1px solid grey;padding-top:30px;padding-bottom:30px;">
         <div class="col s4 m2 ">
               <el-button type="info" style="width:100%;margin:10px 0;"  @click="step=0">Back to authors</el-button>
         </div>
         
         <div class="col s8 m4 offset-m6">
               <el-button type="primary" @click="addnewAbsautore" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;">NEW AUTHOR</el-button>
         </div>
      </div>

      <autoreCerca v-on:absautoreAdded="absautoreAdded"></autoreCerca>
   </div>



   <el-form v-if="step==2" ref="formBasic" :model="item.row" @submit.native.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;" class="label-30">

Please write full first names rather than initials

   <div class="row " style="margin-top:20px;">
      <div class="col s12 m6">
      <el-form-item label="Surname" prop="cognome">
        <el-input  v-model="item.row.cognome"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="First Name" prop="nome">
        <el-input  v-model="item.row.nome"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12" >
      <el-form-item label="Affiliation" prop="affiliazione">
        <el-autocomplete v-model="item.row.affiliazione" placeholder="Please insert affiliation" style="width:100%;" :fetch-suggestions="affSearch" clearable></el-autocomplete>
        <!--
           <el-input  type="textarea" :rows="4" v-model="item.row.affiliazione"></el-input>
         -->
      </el-form-item>
      </div>

      <div class="col s12"><div class="el-form-item__content" style="line-height:1.5em;margin-bottom:8px;">
         Example: Unit, Department, University / Hospital, City, Country
      </div></div>


   </div>

   <div class="row pad" style="margin-top:20px;border-top:1px solid grey;padding-top:30px;padding-bottom:30px;">
      <div class="col s4 m2 ">
         <el-button type="info" style="width:100%;margin:10px 0;"  @click="step=0">Back to authors</el-button>
      </div>
      
      <div class="col s6 m4 offset-m6">
            <el-button type="primary" @click="onSubmit" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;">SAVE AUTHOR AND ADD TO ABSTRACT</el-button>
      </div>
   </div>


    </el-form>
<!-- 
<el-button type="primary" @click="emailFirst" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;">Email</el-button>
-->
</div>
</template>

<script>
import dbItem from '../teras/dbItem'
import autoreAbstract from './Autore-abstract.vue'
import autoreCerca from './Autore-cerca.vue'
export default {
  name: 'abstract-autore',
  components: {
     autoreAbstract,
      autoreCerca
  },
  data() {
    return {
       step: 0,
       item: {}
    }
  },
  created () {
    console.log("Arrivo al abstract-testo.vue con id "+this.$abstract.profile.row.id)
    this.item = new dbItem({table:'autore'})
    this.item.new().then((data) => {
    })
  },
   mounted () {
      this.getAutori()
   },
  beforeDestroy () {

  },
   methods: {
      affSearch(queryString, cb) {
        var results = queryString ? this.$teras._affiliazione.filter(this.createFilter(queryString)) : [];
        console.log(cb)
        cb(results);
      },
      createFilter(queryString) {
        return (aff) => {
           console.log(queryString.toLowerCase()+' » '+aff.value.toLowerCase())
          return (aff.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        }
      },

      getAutori(){
         this.$axios.query('fetchAll',`SELECT * FROM autore GROUP BY MD5(REPLACE(CONCAT(cognome,nome,affiliazione)," ","")) ORDER BY cognome,nome`,{},this.$teras,'_autore')
         this.$axios.query('fetchAll',`SELECT id,affiliazione AS value FROM autore GROUP BY affiliazione ORDER BY affiliazione`,{},this.$teras,'_affiliazione')
      },
      addAbsautore(){
         this.step=1
      },
      addnewAbsautore(){
         this.step=2
      },
      onCancel() {
         this.$router.push('/home/')
      },
      onSubmit() {
         this.$refs.formBasic.validate(async (valid) => {
         if (valid) {  
            this.Save()
         } else {
            this.$alert('Not all fields have been filled in correctly!', this.$teras.alert_error)
            return false;
         }
         });
      },
      async Save(){
         this.$axios.query('fetchRow',`SELECT * FROM autore WHERE MD5(REPLACE(CONCAT(cognome,nome,affiliazione)," ",""))=MD5(REPLACE(CONCAT(→cognome,→nome,→affiliazione)," ",""))`,{cognome: this.item.row.cognome, nome: this.item.row.nome, affiliazione: this.item.row.affiliazione}).then(async (response) => {
            console.log("Finita la query autore")
            if(response.result.id > 0){
            }else{
               console.log("Provo a salvare autore")

               this.item.row.cognome = this.item.row.cognome.toUpperCase()
               this.item.row.nome = this.item.row.nome.toUpperCase()
               await this.item.save()
               this.getAutori()
               console.log("Provo a salvare abstract_autore")
               let absAutore = new dbItem({table:'abstract_autore'})
               await absAutore.new()
               absAutore.row.autore = this.item.row.id
               absAutore.row.abstract = this.$abstract.profile.row.id
               absAutore.row.numero = this.$abstract._autore.length+1
               let primo = await this.$axios.query('fetchOne',`SELECT COUNT(*) FROM abstract_autore WHERE primo=1 AND abstract=←abstract`,{abstract: this.$abstract.profile.row.id})
               if(primo.result==0){
                  absAutore.row.primo = 1
               }
               await absAutore.save()
               this.absautoreAdded(this.item.row)
            }
            return new Promise((resolve, reject) => {resolve("Fatto")})
         }).catch((error) => {return(error)})    
      },
      absautoreAdded(item){
         this.$alert('Author ('+item.cognome+' '+item.nome+') added!', this.$teras.alert_success)
         this.$abstract.resetPreview()
         this.$abstract.getAutori()
         this.$contatto.getAbstract()
         this.step=0
         this.item.new()
      }

   },
  computed: {
    rules:function() {
      var rulesNow = {
        cognome: [
          { required: true, message: 'Il cognome è obbligatorio' }
        ],
        nome: [
          { required: true, message: 'Il nome è obbligatorio'  }
        ],
        affiliazione: [
          { required: true, message: 'L\'affiliazione è obbligatoria'}
        ]
      }
      return rulesNow
    }
  }
}
</script>
<style scoped>
</style>